module.exports = __webpack_public_path__ + "img/8_International_journal_of_biological_sciences_cover.114a790a.jpg";